import * as React from 'react';

const ArrowClock24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.872 21.25c5.189 0 9.378-4.15 9.378-9.25A9.205 9.205 0 0 0 12 2.75c-2.576 0-4.532 1.145-5.982 2.555-.997.97-1.742 2.054-2.263 2.945H7a.75.75 0 0 1 0 1.5H2A.75.75 0 0 1 1.25 9V4a.75.75 0 0 1 1.5 0v3.014A15 15 0 0 1 4.972 4.23C6.62 2.628 8.931 1.25 12 1.25c6.011 0 10.75 4.816 10.75 10.75 0 5.946-4.88 10.75-10.878 10.75-4.99 0-9.203-3.324-10.48-7.864a.75.75 0 1 1 1.443-.406c1.097 3.9 4.724 6.77 9.037 6.77"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.25 8a.75.75 0 0 0-1.5 0v4.624c0 .265.14.51.367.645l4 2.376a.75.75 0 1 0 .766-1.29l-3.633-2.158z"
  }
));
ArrowClock24.Size = 24;
ArrowClock24.Title = "ArrowClock";

export { ArrowClock24 as default };
